export default __webpack_public_path__ + "static/65cd414ee53b179b1ec487c5c7c6fd23.png";